export type PadState =
  | { status: 'empty' }
  | { status: 'encoding'; sourceName: string; progress: number }
  | {
      status: 'ready'
      sourceName: string
      encodedBlob: Blob
      objectUrl: string
      skippedEncode: boolean
    }
  | { status: 'error'; sourceName: string; message: string }

export const PAD_COUNT = 35
export const PAD_COLUMNS = 7
export const PAD_ROWS = 5

export function emptyPads(): PadState[] {
  return Array.from({ length: PAD_COUNT }, () => ({ status: 'empty' as const }))
}

export function padLabel(index: number): string {
  return String(index + 1).padStart(2, '0')
}
